import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { Skeleton } from "@mui/material";
import { Link } from "react-router-dom";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import CashInModal from "./CashInModal";
import CashOutModal from "./CashOutModal";
import OpenBalanceModal from "./OpenBalanceModal";
import CloseBalanceModal from "./CloseBalanceModal";
import DeleteModal from "../../../constants/DeleteModal";
import ReactPaginate from "react-paginate";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import ViewBoxCash from "./ViewBoxCash";
import Table from "../../../constants/Table";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { AddIcon, CoinIcon, CoinStackIcon, DownloadIcon, MinusIcon, ShowIcon, SpreadSheetIcon, TrashIcon } from "../../../constants/Icons";
import { CalendarIcon } from "@mui/x-date-pickers";
const Boxcash = ({ isActive }) => {
  const hasFetched = useRef(false);
  const containerRef = useRef(null);
  const [cashdate, setCashDate] = useState(dayjs());
  const [cashDateApi, setCashDateApi] = useState("");
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [isPreLoading, setPreLoading] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isBoxcashData, setBoxcashData] = useState([]);
  const [isBalanceData, setBalanceData] = useState({
    total_balance: 0,
    closing_balance: 0,
    opening_balance: 0,
    previous_closing_balance: 0,
  });
  const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  const [isCashInModalOpen, setCashInModalOpen] = useState(false);
  const [isCashOutModalOpen, setCashOutModalOpen] = useState(false);

  const [isDeleteData, setDeleteData] = useState();
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const [isOBalanceModalOpen, setOBalanceModalOpen] = useState(false);
  const [isCBalanceModalOpen, setCBalanceModalOpen] = useState(false);
  const [isClosingData, setClosingData] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const perPage = 10;

  const [isLoading, setIsLoading] = useState(true);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
  const [isViewBoxcashModalOpen, setViewBoxcashModal] = useState(false);
  const [isViewBoxcashData, setViewBoxcashData] = useState(null);
  const { isUser, updateSettings } = useAuth();
  const serverTime = GetServerLiveTime();
  const { permission, hasPermission, globelPopupOpen, storeSettings } =
    usePermission();
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const iso = serverTime.toISOString();
  const currentDate = DateConverter.convertToTimeZone(iso, isUser?.timezone);

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const formatTrackMode = (cmode) => {
    switch (cmode?.toUpperCase()) {
      case "CASHIN":
        return "Cash In";
      case "CASHOUT":
        return "Cash Out";
      case "SALE":
        return (
          <div className="d-flex align-items-center">
            SALE <ShowIcon iClass={"ms-1 fs-14"}/>
          </div>
        );
      case "PAYLATER":
        return "PAYLATER";
      case "OPENING":
        return "OPENING";
      default:
        return cmode;
    }
  };

  const getBgColor = (status) => {
    if (!status || typeof status !== "string") return "bg-label-secondary";
    switch (status.toLowerCase()) {
      case "cashin":
        return "bg-label-plus";
      case "cashout":
        return "bg-label-minus";
      case "sale":
        return "bg-label-moon";
      case "opening":
        return "bg-label-flower";
      case "closing":
        return "bg-label-fruit";
      case "paylater":
        return "bg-label-fire";
      case "expense":
        return "bg-label-expense";
      default:
        return "bg-label-secondary";
    }
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleCashDate = (selectedDayjs) => {
    if (!selectedDayjs) return;

    setCashDate(selectedDayjs);

    const isoDateTime = selectedDayjs.toISOString();
    const tzDate = DateConverter.convertToTimeZone(
      isoDateTime,
      isUser?.timezone,
    );

    setCashDateApi(tzDate);
    handleBoxCashList(tzDate, 1);
  };

  const handleBoxCashList = async (cashdate, page = 1, limit = perPage) => {
    setPreLoading(true);
    try {
      if (!checkNetwork()) return;

      const cashdata = encodeURIComponent(cashdate);

      const pageno = page;
      const response = await AxiosInstance.get(
        `module/boxcash/list-boxcash?cashdate=${cashdata}&pageno=${pageno}&limit=${limit}`,
      );

      const result = response?.data?.results;
      const pagination = result?.pagination;

      setBoxcashData(result?.boxcashList || []);
      setBalanceData(result?.balanceData || {});

      if (!pagination) {
        setTotalPages(0);
        setTotalCount(0);
        setCurrentPage(1);
      } else {
        setTotalPages(pagination.totalPages);
        setTotalCount(pagination.totalCount);
        setCurrentPage(pagination.currentPage);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
    }
  };

  const handleCashInOpen = () => {
    if (
      hasPermission("BOXCASH", "BOXCASH:cashIn") ||
      permission === undefined
    ) {
      setCashInModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleCashInClose = () => {
    setCashInModalOpen(false);
  };

  const handleCashIn = async (amount, title, description) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        cashdate: cashdate,
        title: title,
        amount: CurrencyConverter.toSubunit(amount || 0, "INR"),
        description: description,
      };
      const response = await AxiosInstance.post(`module/boxcash/cash-in`, data);
      const result = response?.data?.results.cashData;
      // setBoxcashData((prev) => [result, ...(prev.boxcashList || []), ...prev.slice(0,prev.length - 1),]);
      // setBoxcashData((prev) => {
      //   const dataList = prev.boxcashList || prev;
      //   const updatedList =
      //     dataList.length >= 10
      //       ? [result, ...dataList.slice(0, dataList.length - 1)]
      //       : [result, ...dataList];

      //   return updatedList;
      // });
      setBoxcashData((prev) => {
        if (currentPage !== 1) {
          return prev;
        }
        const updatedList = [result, ...prev];
        if (updatedList.length > perPage) {
          return updatedList.slice(0, perPage);
        }
        return updatedList;
      });
      setBalanceData(response?.data?.results?.balanceData);
      setTotalCount((prev) => prev + 1);
      setTotalPages(Math.ceil((totalCount + 1) / perPage));
      // await handleBoxCashList(cashdate, 1, perPage);
      showAlert("success", Messages.SUCCESS.CASH_ADDED);
      handleCashInClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleCashOutOpen = () => {
    if (
      hasPermission("BOXCASH", "BOXCASH:cashOut") ||
      permission === undefined
    ) {
      setCashOutModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleCashOutClose = () => {
    setCashOutModalOpen(false);
  };

  const handleCashOut = async (amount, title, description) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        cashdate: cashdate,
        title: title,
        amount: CurrencyConverter.toSubunit(amount || 0, "INR"),
        description: description,
      };
      const response = await AxiosInstance.post(
        `module/boxcash/cash-out`,
        data,
      );

      const result = response?.data?.results.cashData;
      setBoxcashData((prev) => {
        // const dataList = prev.boxcashList || prev;
        // const updatedList =
        //   dataList.length >= 10
        //     ? [result, ...dataList.slice(0, dataList.length - 1)]
        //     : [result, ...dataList];
        if (currentPage !== 1) {
          return prev;
        }
        const updatedList = [result, ...prev];

        if (updatedList.length > perPage) {
          return updatedList.slice(0, perPage);
        }

        return updatedList;
      });
      setTotalCount((prev) => prev + 1);
      setTotalPages(Math.ceil((totalCount + 1) / perPage));

      setBalanceData(response?.data?.results?.balanceData);
      // await handleBoxCashList(cashdate, 1, perPage);
      showAlert("success", Messages.SUCCESS.CASH_ADDED);
      handleCashOutClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const openDeleteModal = (cItem) => {
    if (
      hasPermission("BOXCASH", "BOXCASH:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDelete = async () => {
    setBtnLoading(true);
    try {
      const cdate = new Date(cashdate);
      const formattedDate = cdate.toISOString().split("T")[0];
      if (!checkNetwork()) return;

      const response = await AxiosInstance.delete(
        `module/boxcash/delete-boxcash/${isDeleteData._id}`,
      );
      const newCount = totalCount - 1;
      const newTotalPages = Math.ceil(newCount / perPage);
      let newPage = currentPage;
      if (newPage > newTotalPages) {
        newPage = newTotalPages;
      }
      if (newCount === 0) {
        newPage = 1;
      }
      // await handleBoxCashList(cashdate, newPage, perPage);
      setTotalCount(newCount);
      setTotalPages(newTotalPages);
      setCurrentPage(newPage);
      setBoxcashData((prev) =>
        prev.filter(
          (item) => item._id !== response.data.results.deletedCashData._id,
        ),
      );
      setBalanceData(response?.data?.results?.balanceData || {});
      showAlert("success", Messages.SUCCESS.CASH_REMOVED);
      closeDeleteModal();
      handleBoxcashClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const closeDeleteModal = () => {
    setDeleteData(null);
    setDeleteModalOpen(false);
  };

  const handleOBalanceOpen = () => {
    if (
      hasPermission("BOXCASH", "BOXCASH:addOpeningBalance") ||
      permission === undefined
    ) {
      setOBalanceModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleOBalanceClose = () => {
    setOBalanceModalOpen(false);
  };

  const handleSaleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
    // navigate(location.pathname, { replace: true, state: {} });
  };

  const handleSaleView = async (item) => {
    if (item.trackmode === "SALE") {
      const data = await handleSaleItems(item.trackid);
      if (data) {
        setViewData(data);
        setViewModalOpen(true);
        setViewTempModalOpen(true);
      }
    }
  };

  const handleView = async (item) => {
    setViewBoxcashData(item);
    setViewBoxcashModal(true);
  };
  const handleBoxcashClose = () => {
    setViewBoxcashModal(false);
    setViewBoxcashData(null);
  };
  function convertToYYYYMMDD(dateString) {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string");
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const convertToISOWithOffset = (dateString) => {
    const date = new Date(dateString);

    const pad = (n) => String(n).padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    // Get timezone offset
    const offsetMinutes = -date.getTimezoneOffset();
    const offsetSign = offsetMinutes >= 0 ? "+" : "-";
    const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
    const offsetMins = pad(Math.abs(offsetMinutes) % 60);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${offsetSign}${offsetHours}:${offsetMins}`;
  };

  const handleOpeningBalance = async (amount) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      const data = {
        cashdate: cashdate,
        title: "Opening balance",
        amount: CurrencyConverter.toSubunit(amount || 0, "INR"),
      };
      const response = await AxiosInstance.post(
        `module/boxcash/add-opening-balance`,
        data,
      );

      const result = response?.data?.results.cashData;

      setBoxcashData((prev) => {
        const existingIndex = prev.findIndex((item) => item._id === result._id);
        if (existingIndex !== -1) {
          const updatedList = [...prev];
          updatedList[existingIndex] = {
            ...updatedList[existingIndex],
            ...result,
          };
          return updatedList;
        }
        return [...prev, result];
      });

      setBalanceData(response?.data?.results.balanceData);
      // await handleBoxCashList(cashdate, 1, perPage);
      showAlert("success", Messages.SUCCESS.CASH_ADDED);
      handleOBalanceClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };
  const handleCBalanceOpen = async () => {
    if (
      hasPermission("BOXCASH", "BOXCASH:viewClosingBalance") ||
      permission === undefined
    ) {
      try {
        if (!checkNetwork()) return;
        const formattedDate = convertToISOWithOffset(cashdate);
        // const data = {
        //   cashdate: encodeURIComponent(cashdate),
        // };

        const response = await AxiosInstance.get(
          `module/boxcash/view-closing-balance?cashdate=${encodeURIComponent(
            formattedDate,
          )}`,
        );

        setClosingData(response?.data?.results.cashData || []);
        setCBalanceModalOpen(true);
      } catch (error) {
        handleError(error, showAlert);
        return false;
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleCBalanceClose = () => {
    setCBalanceModalOpen(false);
  };

  const handleClosingBalance = async (closeBalance) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      const data = {
        cashdate: cashdate,
        title: "Closing Cash",
        description: "End of day cash",
        amount: closeBalance.totalAmount,
        denominationData: closeBalance.denominations.map((item) => ({
          denominationName: item.denominationName,
          denominationValue: item.denominationValue,
          quantity: item.quantity,
        })),
      };

      const response = await AxiosInstance.post(
        `module/boxcash/add-closing-balance`,
        data,
      );

      const result = response?.data?.results.cashData;
      setBoxcashData((prev) => {
        const existingIndex = prev.findIndex((item) => item._id === result._id);
        if (existingIndex !== -1) {
          const updatedList = [...prev];
          updatedList[existingIndex] = {
            ...updatedList[existingIndex],
            ...result,
          };
          return updatedList;
        }
        return [...prev, result];
      });

      setBalanceData(response?.data?.results.balanceData);
      // await handleBoxCashList(cashdate, 1, perPage);
      showAlert("success", Messages.SUCCESS.CASH_ADDED);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewTempModalOpen(false);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      const results = response.data.results;
      return results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const exportToCSV = () => {
    if (!(isBoxcashData?.length > 0)) {
      showAlert("warning", "No data available to export");
      return;
    }
    const headers = `S No,Mode,Added On,Description,Amount`;
    const clean = (val) => (val ?? "").toString().replace(/[\r\n,;]/g, " ");
    const rows = isBoxcashData
      .map((item, index) => {
        const serialNo = totalCount - (currentPage - 1) * perPage - index;
        let dateTime = "";
        if (item.createdAt) {
          const converted = DateConverter.convertToTimeZone(
            item.createdAt,
            isUser?.timezone,
          );
          const display = DateConverter.ISOToDisplayFormat(converted);
          dateTime = `${display.date} ${display.time}`;
        }
        const description = clean(
          [item?.title, item?.description].filter(Boolean).join(" - "),
        );
        const row = [
          serialNo,
          clean(item.trackmode),
          clean(dateTime),
          description,
          clean(CurrencyConverter.toCurrency(item.amount || 0, "INR")),
        ];
        return row.join(",");
      })
      .join("\n");
    const csvContent = [headers, rows].join("\n");
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `Boxcash_${formatDate(new Date())}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    // 🔒 Do nothing if Boxcash tab is not active
    if (!isActive || !containerRef.current) return;

    const root = containerRef.current;

    const handleArrowAndEnter = (e) => {
      if (
        isViewModalOpen ||
        isCBalanceModalOpen ||
        isDeleteModalOpen ||
        isOBalanceModalOpen ||
        isCashOutModalOpen ||
        isCashInModalOpen ||
        globelPopupOpen
      ) {
        return;
      }

      if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

      e.preventDefault();

      // ✅ ONLY Boxcash rows
      const tableRows = Array.from(root.querySelectorAll("table tbody tr"));

      if (!tableRows.length) return;

      const currentRow = document.activeElement?.closest("tr");
      let currentIndex = tableRows.indexOf(currentRow);

      // Enter key
      if (e.key === "Enter") {
        if (currentIndex >= 0) {
          const item = tableRows[currentIndex].dataset?.item
            ? JSON.parse(tableRows[currentIndex].dataset.item)
            : null;

          if (item) {
            if (item.trackmode === "CASHIN" || item.trackmode === "CASHOUT") {
              handleView(item);
            } else if (item.trackmode === "SALE") {
              handleSaleView(item);
            }
          }
        }
        return;
      }

      // No row focused yet
      if (currentIndex === -1) {
        const startIndex = e.key === "ArrowUp" ? tableRows.length - 1 : 0;

        tableRows[startIndex].tabIndex = 0;
        tableRows[startIndex].focus();
        return;
      }

      tableRows[currentIndex].tabIndex = -1;

      const nextIndex =
        e.key === "ArrowDown"
          ? (currentIndex + 1) % tableRows.length
          : (currentIndex - 1 + tableRows.length) % tableRows.length;

      const nextRow = tableRows[nextIndex];
      nextRow.tabIndex = 0;
      nextRow.focus();
    };

    window.addEventListener("keydown", handleArrowAndEnter);
    return () => window.removeEventListener("keydown", handleArrowAndEnter);
  }, [
    isActive, // ✅ IMPORTANT
    isViewModalOpen,
    isDeleteModalOpen,
    isCBalanceModalOpen,
    isOBalanceModalOpen,
    isCashOutModalOpen,
    isCashInModalOpen,
    globelPopupOpen,
  ]);

  useEffect(() => {
    if (!isActive || !containerRef.current) return;

    containerRef.current
      .querySelectorAll("tr")
      .forEach((tr) => (tr.tabIndex = -1));
  }, [isActive]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const isoDateTime = serverTime.toISOString();
    const tzDate = DateConverter.convertToTimeZone(
      isoDateTime,
      isUser?.timezone,
    );

    const dayjsDate = dayjs(tzDate); // ✅ convert to dayjs
    setCashDate(dayjsDate);

    if (hasPermission("BOXCASH", "BOXCASH:list") || permission === undefined) {
      handleBoxCashList(tzDate); // API still uses string/date
    }
  }, []);

  // console.log("cashdate", cashdate);
  // console.log("serverTime", serverTime);

  useEffect(() => {
    if (!serverTime) return;

    const today = dayjs(serverTime); // ✅ Server time

    setCashDate(today);

    const iso = serverTime.toISOString();
    const tzDate = DateConverter.convertToTimeZone(iso, isUser?.timezone);

    setCashDateApi(tzDate);
    handleBoxCashList(tzDate, 1);
  }, [isUser?.timezone]);

  useEffect(() => {
    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  return (
    <>
      <div ref={containerRef}>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="page-breadcrumb d-flex align-items-center paddingBottom">
              <div className="breadcrumb-title pe-3">Box Cash</div>
              <div className="ms-auto d-flex gap-2">
                <button
                  className="btn btn-sm btn-export dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <DownloadIcon/> Export
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" onClick={exportToCSV}>
                      <SpreadSheetIcon/>{" "}
                      <span className="icon-text">Excel (CSV)</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card radius-10 mb-0">
                  <div className="card-widget-separator-wrapper">
                    <div className="card-header justify-content-between align-items-center px-3 py-3">
                      <div className="d-md-flex align-items-center">
                        <div>
                          <div className="input-group w-200">
                            <button className="input-group-text">
                              <CalendarIcon/>
                            </button>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                open={openDatePicker}
                                onOpen={() => setOpenDatePicker(true)}
                                onClose={() => setOpenDatePicker(false)}
                                disableOpenPicker
                                value={cashdate}
                                onChange={(newValue) => {
                                  handleCashDate(newValue);
                                  setOpenDatePicker(false);
                                }}
                                format="DD MMM YYYY"
                                maxDate={dayjs(serverTime)} // ✅ today only, no tomorrow
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    className: "form-control cursor-pointer",
                                    onClick: () => setOpenDatePicker(true),
                                    inputProps: { readOnly: true },
                                    onKeyDown: (e) => e.preventDefault(),
                                    sx: {
                                      "& .MuiInputBase-input": {
                                        cursor: "pointer",
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                        <div className="text-center py-1 ms-2">
                          <div className="chip border-0 text-dark bg-light-blue mb-0">
                            Yesterday Closing Balance : ₹
                            {CurrencyConverter.toCurrency(
                              isBalanceData?.previous_closing_balance || 0,
                              "INR",
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-body mb-0">
                      <div className="row g-3">
                        <div className="col-lg-3">
                          <Link onClick={handleOBalanceOpen}>
                            <div className="d-flex justify-content-between align-items-center card-widget-1 p-2 radius-10 border">
                              <div>
                                <p className="mb-0">Opening Balance</p>
                                {isPreLoading ? (
                                  <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={13}
                                    className="radius-5 bg-light-grey my-2"
                                  />
                                ) : (
                                  (() => {
                                    return (
                                      <>
                                        <h4 className="mb-0 text-secondary">
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            isBalanceData?.opening_balance || 0,
                                            "INR",
                                          )}
                                        </h4>
                                      </>
                                    );
                                  })()
                                )}
                              </div>
                              <div className="avatar me-sm-0">
                                <span className="avatar-initial rounded bg-label-light">
                                  <CoinIcon/>
                                </span>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-lg-6">
                          <div
                            className={`height-60 d-flex text-center justify-content-between align-items-center card-widget-1 radius-10 border-1 ${
                              isPreLoading
                                ? "bg-label-grey"
                                : isBalanceData?.total_balance >= 0
                                  ? "bg-label-success"
                                  : "bg-label-danger"
                            }`}
                          >
                            <div className="me-sm-0">
                              <button
                                className="btn btn-danger box-btn-left"
                                onClick={handleCashOutOpen}
                              >
                                <MinusIcon/>
                                <span className="d-title"> Cash Out </span>
                              </button>
                            </div>
                            <div>
                              {isPreLoading ? (
                                <Skeleton
                                  variant="rectangular"
                                  width="100%"
                                  height={13}
                                  className="radius-5 bg-light-grey my-2"
                                />
                              ) : (
                                (() => {
                                  return (
                                    <>
                                      <h4
                                        className={`mt-2 mb-0 ${
                                          isBalanceData?.total_balance >= 0
                                            ? "text-success"
                                            : "text-danger"
                                        }`}
                                      >
                                        ₹
                                        {CurrencyConverter.toCurrency(
                                          isBalanceData?.total_balance || 0,
                                          "INR",
                                        )}
                                      </h4>
                                    </>
                                  );
                                })()
                              )}
                              <p
                                className={`mb-1 mt-0 ${
                                  isPreLoading
                                    ? "text-grey"
                                    : isBalanceData?.total_balance >= 0
                                      ? "text-success"
                                      : "text-danger"
                                }`}
                              >
                                Cash In Box
                              </p>
                            </div>
                            <div className="me-sm-0">
                              <button
                                className="btn btn-success box-btn-right"
                                onClick={handleCashInOpen}
                              >
                                <AddIcon/>
                                <span className="d-title"> Cash In </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <Link onClick={handleCBalanceOpen}>
                            <div className="d-flex justify-content-between align-items-center card-widget-1 p-2 radius-10 border">
                              <div>
                                <p className="mb-0">Closing Balance</p>
                                {isPreLoading ? (
                                  <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={13}
                                    className="radius-5 bg-light-grey my-2"
                                  />
                                ) : (
                                  (() => {
                                    return (
                                      <>
                                        <h4 className="mb-0 text-secondary">
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            isBalanceData?.closing_balance || 0,
                                            "INR",
                                          )}
                                        </h4>
                                      </>
                                    );
                                  })()
                                )}
                              </div>
                              <div className="avatar me-sm-0">
                                <span className="avatar-initial rounded bg-label-light">
                                  <CoinStackIcon/>
                                </span>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="card-body px-0">
                      <Table
                        loading={isPreLoading}
                        data={isBoxcashData}
                        onRowClick={(item) => {
                          if (
                            item.trackmode === "CASHIN" ||
                            item.trackmode === "CASHOUT"
                          ) {
                            handleView(item);
                          } else if (item.trackmode === "SALE") {
                            handleSaleView(item);
                          }
                        }}
                        columns={[
                          {
                            label: "S.No",
                            render: (_, index) => (
                              <>
                                {totalCount -
                                  (currentPage - 1) * perPage -
                                  index}
                              </>
                            ),
                          },
                          {
                            label: "Mode",
                            render: (item) => (
                              <span
                                className={`cursor-poInter badge rounded-pill ${getBgColor(
                                  item.trackmode,
                                )}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSaleView(item);
                                }}
                              >
                                {formatTrackMode(item.trackmode)}
                              </span>
                            ),
                          },
                          {
                            label: "Added On",
                            render: (item) => (
                              <>
                                {item.createdAt &&
                                  DateConverter.ISOToDisplayFormat(
                                    DateConverter.convertToTimeZone(
                                      item.createdAt,
                                      isUser?.timezone,
                                    ),
                                  ).date}{" "}
                                {item.createdAt &&
                                  DateConverter.ISOToDisplayFormat(
                                    DateConverter.convertToTimeZone(
                                      item.createdAt,
                                      isUser?.timezone,
                                    ),
                                  ).time}
                              </>
                            ),
                          },
                          {
                            label: "Description",
                            render: (item) => (
                              <div className="d-flex flex-column">
                                <small className="text-truncate d-none d-sm-block">
                                  {item?.title} - {item.description}
                                </small>
                              </div>
                            ),
                          },
                          {
                            label: "Amount",
                            render: (item) => (
                              <span className="fw-medium fs-15">
                                {item.cmode === "CASHIN" ? (
                                  <div className="badge text-plus">
                                    + ₹
                                    {CurrencyConverter.toCurrency(
                                      item.amount || 0,
                                      "INR",
                                    )}
                                  </div>
                                ) : (
                                  <div className="badge text-minus">
                                    - ₹
                                    {CurrencyConverter.toCurrency(
                                      item.amount || 0,
                                      "INR",
                                    )}
                                  </div>
                                )}
                              </span>
                            ),
                          },
                          {
                            label: "Actions",
                            render: (item) => (
                              <div className="order-actions opacity-0 opacity-md-100">
                                {item.trackmode === "CASHIN" ||
                                item.trackmode === "CASHOUT" ? (
                                  <button
                                    type="button"
                                    className="btn btn-label-danger shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openDeleteModal(item);
                                    }}
                                  >
                                    <TrashIcon/>
                                  </button>
                                ) : null}
                                {item.trackmode === "SALE" ? (
                                  <button
                                    type="button"
                                    className="btn-label-info shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSaleView(item);
                                    }}
                                  >
                                    <ShowIcon/>
                                  </button>
                                ) : null}
                              </div>
                            ),
                          },
                        ]}
                      />
                      {totalPages > 0 && (
                        <div className="d-flex justify-content-center mt-3">
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) =>
                              handleBoxCashList(
                                cashDateApi,
                                selected + 1,
                                perPage,
                              )
                            }
                            forcePage={currentPage - 1}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isCashInModalOpen && (
            <CashInModal
              isActive={isActive}
              onClose={handleCashInClose}
              onCashIn={handleCashIn}
              isBtnLoading={isBtnLoading}
            />
          )}

          {isCashOutModalOpen && (
            <CashOutModal
              isActive={isActive}
              onClose={handleCashOutClose}
              onCashOut={handleCashOut}
              isBtnLoading={isBtnLoading}
            />
          )}

          {isOBalanceModalOpen && (
            <OpenBalanceModal
              isActive={isActive}
              onClose={handleOBalanceClose}
              onOBalance={handleOpeningBalance}
              onBalanceData={isBalanceData}
              isBtnLoading={isBtnLoading}
            />
          )}

          {isDeleteModalOpen && (
            <DeleteModal
              onClose={() => setDeleteModalOpen(false)}
              onConfirm={handleDelete}
              isLable={" Boxcash " + isDeleteData?.trackmode}
              isBtnLoading={isBtnLoading}
            />
          )}

          {isCBalanceModalOpen && (
            <CloseBalanceModal
              onClose={handleCBalanceClose}
              onCBalance={handleClosingBalance}
              onBalanceData={isBalanceData}
              onClosingData={isClosingData}
              isBtnLoading={isBtnLoading}
            />
          )}

          {!templateId && isViewTempModalOpen && (
            <InvoiceTempPreview
              isData={isViewData}
              onClose={() => setViewTempModalOpen(false)}
              onAdd={handleSetTemplate}
            />
          )}
          {templateId && isViewModalOpen && (
           <TemplateModalLayout
                    isOpen={isViewModalOpen}
                    isData={isViewData}
                    onClose={handleSaleClose}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    setSaleData={setViewData}
                    isActive={isActive}
                  />        
          )}
          {isViewBoxcashModalOpen && (
            <ViewBoxCash
              isData={isViewBoxcashData}
              onClose={handleBoxcashClose}
              handleDelete={handleDelete}
              isBtnLoading={isBtnLoading}
              setDeleteModalOpen={setDeleteModalOpen}
              isDeleteModalOpen={isDeleteModalOpen}
              setDeleteData={setDeleteData}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Boxcash;
